module.exports = __webpack_public_path__ + "img/reciprocal_init.ff6a3445.png";